import { getKeyByForm, relations } from './meta'
import { initialTmState } from './state'
import { getReducer } from 'core/classes/helpers/store/database'

export const searchReducer = getReducer(
  initialTmState,
  relations,
  getKeyByForm,
  '@SEARCH_SAVE',
  '@SEARCH_REMOVE'
)
